import { useState } from 'react';
import { HelpCircle, Minus, Plus } from 'lucide-react';
import { FAQ_ITEMS } from './psychologistLandingData';

export function PsychologistLandingFaqSection() {
	const [openId, setOpenId] = useState<string | null>(null);

	const toggleQuestion = (id: string) => {
		setOpenId((prev) => (prev === id ? null : id));
	};

	return (
		<section
			id="central-ajuda"
			className="border-b border-brand-orange/10 bg-[#fffcfb] py-24"
		>
			<div className="mx-auto max-w-3xl px-6 text-center">
				<h2 className="mb-12 text-3xl font-bold text-[#3d3431]">
					Ficou com alguma dúvida?
				</h2>

				<div className="space-y-4 text-left">
					{FAQ_ITEMS.map((item) => {
						const isExpanded = openId === item.id;
						return (
							<div
								key={item.id}
								className={`overflow-hidden rounded-2xl border bg-white transition-all duration-300 ${
									isExpanded
										? 'border-brand-orange/30 shadow-md shadow-brand-orange/5'
										: 'border-brand-orange/10 hover:border-brand-orange/20'
								}`}
							>
								<button
									type="button"
									onClick={() => toggleQuestion(item.id)}
									className="flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left font-bold text-[#3d3431] focus:outline-none"
									aria-expanded={isExpanded}
								>
									<span className="flex items-center gap-2.5 text-sm md:text-base">
										<HelpCircle
											className={`h-4 w-4 shrink-0 transition-colors ${
												isExpanded
													? 'text-brand-orange'
													: 'text-gray-400'
											}`}
										/>
										{item.question}
									</span>
									<span
										className={`shrink-0 rounded-lg p-1.5 transition-colors ${
											isExpanded
												? 'bg-brand-orange/10 text-brand-orange'
												: 'bg-gray-100 text-gray-400'
										}`}
									>
										{isExpanded ? (
											<Minus className="h-4 w-4" />
										) : (
											<Plus className="h-4 w-4" />
										)}
									</span>
								</button>

								<div
									className={`overflow-hidden transition-all duration-300 ease-in-out ${
										isExpanded
											? 'max-h-[500px] border-t border-brand-orange/5 px-6 py-4 opacity-100'
											: 'max-h-0 opacity-0'
									}`}
								>
									<p className="text-xs font-light leading-relaxed text-gray-500 md:text-sm">
										{item.answer}
									</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}
